import React, { createContext, useContext, useReducer } from 'react'

import { Schedule } from 'services/schedules'

interface State {
  loading: boolean
  schedules: Schedule[]
  currentPage: number
  totalPage: number
  search: string
}

interface Action {
  type: string
  payload?: any
}

const initState: State = {
  loading: false,
  schedules: [],
  currentPage: 1,
  totalPage: 1,
  search: '',
}

const ScheduleContext = createContext<any>(null)

function reducer(state: State, { type, payload }: Action) {
  switch (type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      }
    case 'SET_SCHEDULES':
      return {
        ...state,
        loading: false,
        schedules: payload.data,
        totalPage: payload.meta.last_page,
      }
    case 'SET_CURRENT_PAGE':
      return {
        ...state,
        currentPage: payload,
      }
    case 'SET_SEARCH':
      return {
        ...state,
        search: payload,
        currentPage: 1,
      }
    default:
      return state
  }
}

const ScheduleContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)

  return (
    <ScheduleContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ScheduleContext.Provider>
  )
}

const useScheduleContext = () => {
  return useContext(ScheduleContext)
}

export { ScheduleContextProvider as default, useScheduleContext }
